import {createStore} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {ChangeRate} from '@store/settings/changeRate/change-rate.model';
import {withPagination} from '@ngneat/elf-pagination';
import {withRequestsStatus} from '@ngneat/elf-requests';

export const changeRateStore = createStore(
  { name: 'change-rate'},
  withEntities<ChangeRate>(),
  withPagination(),
  withRequestsStatus(),
);
